import { RouteObject } from 'react-router-dom';
import NoAccess from './pages/errors/NoAccess';

const routes: RouteObject[] = [
  {
    path: 'no-access',
    element: <NoAccess />,
  },
];

export default routes;
